import { Pipe, PipeTransform } from '@angular/core';

import { SharedService } from 'src/app/core/services/shared.service';

@Pipe({
  name: 'selfPublishStatus'
})
export class SelfPublishStatusPipe implements PipeTransform {
  constructor(private sharedService: SharedService) {}

  transform(value: any, ...args: any[]): any {
    const status = {
      declaration: { en: 'New pitch declaration', no: 'Ny kampanje-deklarasjonsskjema' },
      details: { en: 'New pitch details', no: 'Nye kampanje-detaljerskjema' },
      accepted: { en: 'Accepted', no: 'Godtatt' },
      rejected: { en: 'Rejected', no: 'Avvist' },
      sign_declaration: {
        en: 'Requires signing questionnaire: New pitch declaration',
        no: 'Krever signatur av skjema: Ny kampanje-deklarasjonsskjema'
      },
      sign_declaration_progress: {
        en: 'Signing in progress: New pitch declaration',
        no: 'Venter p\u00e5 signering: Ny kampanje-deklarasjonsskjema'
      }
    };
    return status[value][this.sharedService.language];
  }
}
